import Delete from './icon-delete'
import Close from './icon-close'
import Edit from './icon-edit'
import Zoom from './icon-zoom'
import Back from './icon-back'
import Background from './icon-background'
import Text from './icon-text'
import Person from './icon-person'
import Stamp from './icon-stamp'
import Store from './icon-store'
import Home from './icon-home'
import Plus from './icon-plus'
import Down from './icon-down'
import EditText from './icon-text-edit'
import DeleteText from './icon-text-delete'
import Tick from './icon-tick'
import ChatBox from './icon-chatbox'

export default {
  'x-icon-delete': Delete,
  'x-icon-close': Close,
  'x-icon-edit': Edit,
  'x-icon-zoom': Zoom,
  'x-icon-back': Back,
  'x-icon-bg': Background,
  'x-icon-text': Text,
  'x-icon-person': Person,
  'x-icon-stamp': Stamp,
  'x-icon-store': Store,
  'x-icon-home': Home,
  'x-icon-plus': Plus,
  'x-icon-down': Down,
  'x-icon-text-delete': DeleteText,
  'x-icon-text-edit': EditText,
  'x-icon-tick': Tick,
  'x-icon-chatbox': ChatBox,
}
